// extracted by mini-css-extract-plugin
export default {"container":"loader-module__container--3RYUe","section":"loader-module__section--1XY-F","placeHolderShimmer":"loader-module__placeHolderShimmer--3DKjt"};